module.exports = __webpack_public_path__ + "static/TiemposHeadlineWeb-SemiboldItalic-a78066b22b44315aea16430898fc6c7e.eot";